export default {
  app: "Jaohui Workspace",
  newBrief: "New brief",
  myBriefs: "My briefs",
  workbench: "Team workbench",
  members: "Members",
  model: "Model settings",
  logout: "Sign out",
  taskList: "Task list",
  submit: "Confirm and submit",
  addChange: "Add requirement",
  send: "Send",
  emptyQueue: "No submitted briefs yet",
  common: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    add: "Add",
    delete: "Delete",
    submit: "Submit",
    confirm: "Confirm",
    saving: "Saving",
    close: "Close",
    download: "Download",
    previous: "Previous",
    next: "Next",
    all: "All",
    draft: "Draft",
    active: "In progress",
    completed: "Completed",
    pending: "Pending",
    blocked: "Blocked",
    cancelled: "Cancelled",
    fromTo: "{start} to {end}",
  },
  upload: {
    open: "Upload",
    chooseSource: "Choose upload source",
    media: "Photos or videos",
    mediaHint: "Open your device gallery",
    photo: "Photos",
    photoHint: "Choose images from your device gallery",
    file: "Files",
    fileHint: "Choose from device files",
  },
  shell: {
    home: "Workspace",
    collaboration: "My collaboration",
    dispatch: "Dispatch review",
    client: "Client",
    staff: "Team member",
    admin: "Administrator",
    collapse: "Collapse top navigation",
    expand: "Expand top navigation",
    deleteBrief:
      "Delete this Brief? Its conversation, tasks, deliveries, and change history will be permanently removed.",
    deleteNamed: "Delete {title}",
  },
  login: {
    title: "Sign in to Jaohui Workspace",
    hero: "Turn client ideas into executable work.",
    subtitle:
      "Clients communicate in their own language. The team receives a clear Chinese execution brief.",
    access:
      "Invited clients, team members, and administrators enter with separate permissions.",
    hint: "Use the account created by your administrator.",
    username: "Username",
    password: "Password",
    action: "Sign in",
    working: "Signing in…",
    failed: "Sign-in failed",
  },
  brief: {
    genericType: "General requirement",
    intro:
      "Add requirements conversationally, then confirm before submitting to the team.",
    inputPlaceholder:
      "Write your requirement in Chinese, English, French, or mixed languages…",
    resumeFailed: "Could not resume the task",
    pageFailed: "The page did not load. Please retry.",
    sendFailed: "Message failed. Check your connection and retry.",
    documentOnly:
      "Only Word or TXT is accepted here. Upload images and videos to a specific task after creating the project draft.",
    uploadFailed: "File upload failed. Please retry.",
    loading: "Loading...",
    loadFailed: "This page did not load",
    reload: "Reload",
    historyHint:
      "Each Brief keeps its own conversation, tasks, changes, and deliveries.",
    empty: "No Briefs yet.",
    changeTitle: "Edit Brief title",
    autoDetected: "Automatically detected",
    confirmType: "Confirm service type",
    chooseType: "Choose service type",
    changeType: "Change service type",
    confirmedVersion: "Confirmed Brief v{version}",
    deleteCurrent: "Delete current conversation",
    conversation: "Requirement discussion",
    fullSolution: "Full proposal",
    you: "You",
    researchDone: "Research and planning complete",
    stopRun: "Stop current run",
    collapseTrace: "Collapse process",
    expandTrace: "Expand process",
    references: "References",
    uploadDocument: "Upload Word or TXT",
    uploadImage: "Choose images from gallery",
    imageMessage:
      "Please analyze the images I sent and use them to continue refining the requirement.",
    pendingImages: "Images ready to send",
    removeImage: "Remove image",
    imageLimit: "You can send up to 5 images per message",
    messages: "Messages and delivery",
    versions: "Versions and changes",
    confirmed: "Confirmed",
    changeNumber: "Change #{id}",
    waitingTeam: "Awaiting team review",
    changeHint: "The team receives a structured Chinese execution summary.",
  },
  dashboard: {
    title: "Project workspace",
    subtitle: "Track progress, schedules, blockers, and actions.",
    newRequest: "New request",
    awaitingAcceptance: "Needs my review",
    adminReview: "Admin analysis",
    adminClientReview: "Review admin proposal",
    adminConfirmed: "Confirmed, awaiting assignment",
    adminRevision: "Proposal revision",
    assigned: "Assigned to team",
    intake: "Requirement discussion",
    drafting: "Proposal drafting",
    solutionReview: "Proposal review",
    projectDraft: "Project draft",
    submitted: "Submitted",
    teamAccepted: "Accepted by team",
    scheduled: "Scheduled",
    inProgress: "In progress",
    awaiting: "Awaiting acceptance",
    revision: "In revision",
    noDate: "Date pending team review",
    blockedCount: "{count} blocked",
    waitYou: "Waiting for you",
    teamWorking: "Team working",
    collapseTimeline: "Hide timeline",
    showTimeline: "View timeline",
    empty: "No projects in this category.",
    deleteTitle: "Delete {title}",
    deleteConfirm:
      "Delete “{title}”? Its conversation, tasks, deliveries, and change history will be permanently removed.",
  },
  profile: {
    title: "My name and long-term preferences",
    loading: "Loading client profile",
    summary: "{name} · {count} long-term memories",
    preferredName: "How the Agent addresses you",
    organization: "Organization / company",
    industry: "Industry",
    brandSummary: "Brand context",
    preferences: "Long-term preferences, one per line",
    preferencePlaceholder: "Example: Keep final copy in English by default",
    saved: "Profile saved. The Agent will use it automatically.",
    save: "Save profile",
    portrait: "Learned profile",
    portraitVersion: "Profile v{version}",
    memoryEvidence: "Learned long-term memories",
    updated: "Updated {time}",
    emptyMemory:
      "As you continue, the Agent will learn from explicit statements and repeated preferences.",
  },
  agent: {
    processing: "Agent is working",
    ready: "Full proposal is ready",
    missing: "{count} items still need confirmation",
    done: "This run is complete",
    collapse: "Collapse task progress",
    expand: "Expand task progress: {title}",
    title: "Agent task progress",
    runProgress: "Run progress",
    completeness: "Proposal completeness",
    needTalk: "Still to discuss",
    readyHint: "Review the full proposal to create a project draft.",
  },
  solution: {
    overview: "Proposal overview",
    confirmPage: "Review and confirm",
    itemPage: "Item {index} · {title}",
    executionTask: "Execution task",
    fullSolution: "Full proposal",
    waiting: "Waiting for the AI proposal",
    completeness: "{score}% complete",
    webReferences: "Web references",
    checklist: "Two-level execution checklist",
    lockedCopy: "Final copy · preserve original",
    clientTask: "Client task description",
    deliverables: "Deliverables",
    teamDetails: "Team execution details",
    items: "{count} items",
    acceptance: "Acceptance: {items}",
    finalStep: "Final step",
    confirmTitle: "Review and confirm proposal",
    preflight: "Pre-submission checks",
    canAdd: "Can still be added",
    creating: "Creating project draft",
    confirmCreate: "Confirm proposal and create project draft",
    missing: "Still missing: {items}",
    switchPages: "Switch proposal pages",
    emptyHint:
      "The full AI proposal will appear here after you send your request.",
  },
  project: {
    expected: "Expected completion: {date}",
    adminReview: "Review administrator proposal",
    adminReviewHint:
      "Review the proposal, locked copy, and final language. Once confirmed, the administrator assigns the team. Return it with details if changes are needed.",
    reviewPlaceholder: "Confirmation note or requested changes",
    approve: "Confirm",
    revise: "Request changes",
    overview: "Project overview",
    tasks: "Execution checklist",
    timeline: "Timeline",
    changes: "Versions and changes",
    noSolution: "No full proposal yet",
    sources: "References",
    confirmedRequirements: "Confirmed requirements",
    languageTitle: "Final language and locked copy",
    languageHint:
      "Client source text stays unchanged. Chinese is only for team interpretation. Final work uses the selected output language.",
    sourceText: "Client source text",
    sourceLanguage: "Source language",
    outputText: "Final copy",
    outputLanguage: "Output language",
    languageExample: "Example: English",
    policy: "Handling",
    preserve: "Preserve",
    translate: "Translate",
    localize: "Localize",
    clientConfirmed: "Confirmed by client",
    saveLanguage: "Save language settings",
    taskProgress: "Task progress",
    steps: "{done} / {total} steps",
    messages: "Messages and delivery",
    requestTodo: "Request a new to-do",
    acceptance: "Acceptance criteria",
    levelOne: "Stage",
    levelTwo: "Execution step",
    executionReference: "Execution reference",
    executionReferenceHint: "Storyboards, visual notes, or technical specifications",
    check: "Check: {items}",
    assets: "Execution assets",
    preview: "Preview",
    noAssets: "No formal execution assets yet.",
    addChange: "Add change",
    projectVersion: "Project V{version}",
    changeNumber: "Change #{id}",
    awaitingImpact: "Awaiting team impact assessment",
    approveChange: "Approve change",
    reject: "Reject",
    noChanges: "No change history.",
    adminReviewStage: "Submitted for administrator analysis",
    clientReviewStage: "Administrator proposal needs your review",
    confirmedStage: "Confirmed, awaiting assignment",
    revisionStage: "Administrator or client requested changes",
    assignedStage: "Assigned to team",
    submittedStage: "Submitted, awaiting team acceptance",
    acceptedStage: "Accepted by team",
    scheduledStage: "Scheduled",
    inProgressStage: "In progress",
    acceptanceStage: "Awaiting your acceptance",
    revisionWorkStage: "In revision",
    completedStage: "Completed",
  },
  draftEditor: {
    itemPoster: "poster",
    itemTask: "task",
    unitPoster: "poster",
    unitTask: "task",
    title: "Project draft",
    hint: "Review task content and dates, then submit for administrator review.",
    infoPage: "Project information",
    solutionPage: "Full proposal",
    requirementsPage: "Client requirements",
    submitPage: "Submit confirmation",
    itemPage: "Item {index} · {title}",
    executionTask: "Execution task",
    projectName: "Project name",
    start: "Planned start",
    end: "Planned completion",
    expectedEnd: "Expected completion",
    saveInfo: "Save project information",
    confirmedSolution: "Confirmed full proposal",
    requirements: "Explicit client requirement checks",
    requirementsHint:
      "Content, dialogue, themes, restrictions, and notes can be edited. Verify each item before submission.",
    addRequirement: "Add check",
    requirementCategory: "Requirement category",
    attention: "Attention",
    content: "Content",
    dialogue: "Dialogue and copy",
    theme: "Theme",
    other: "Other",
    requirementTitle: "Check item",
    requirementDescription: "Explicit requirement and constraints",
    verified: "Verified",
    deleteRequirement: "Delete check",
    saveRequirements: "Save checks",
    taskList: "{item} list",
    reviewed: "{done} / {total} confirmed. Review each {unit} and its dates.",
    taskName: "{item} name",
    sourceCopy: "Client source / final copy",
    sourceCopyHint:
      "Preserve client-provided text. If there is no final copy, keep the confirmed content description.",
    finalCopy: "Final copy",
    preserveOriginal: "English · preserve original",
    editCopy: "Edit final copy",
    finishEdit: "Finish editing",
    teamBrief: "Chinese production brief",
    saveTask: "Save {item}",
    deleteTask: "Delete {item}",
    optionalAssets: "{item} assets (optional)",
    optionalAssetsHint:
      "Leave empty when already delivered elsewhere, AI-generated, or not required.",
    addAsset: "Add asset",
    chooseFromAlbum: "Choose from gallery",
    chooseFile: "Choose file",
    noAssets: "No formal assets archived.",
    archiveHint: "Conversation references can be archived to this task",
    archive: "Archive {name}",
    confirmItem: "Confirm this item",
    confirmedItem: "Item confirmed",
    executionDetails: "Team execution details",
    concreteSteps: "{count} concrete steps",
    acceptanceLines: "Acceptance criteria (one per line)",
    todoList: "Execution checklist",
    todoTitle: "To-do title",
    addTodo: "Add to-do",
    addTodoPlaceholder: "Enter a concrete, actionable to-do",
    defaultAcceptance: "Complete against confirmed requirements with verifiable output",
    todoDescription: "Complete “{title}” and submit a verifiable result.",
    twoLevel: "Two-level execution checklist",
    levelOne: "Stage",
    levelTwo: "Step",
    stageGoal: "Stage goal and output",
    stageAcceptance: "Stage checks, one per line",
    stepDescription: "Concrete action, input, and output",
    stepAcceptance: "Checks, one per line",
    addStage: "Add stage",
    addStep: "Add step",
    newTask: "Add task",
    finalStep: "Final step",
    submitReview: "Submit for administrator review",
    submitHint:
      "Review project name, dates, client requirements, and every task before submission.",
    validationMissing: "{count} items still need attention",
    validationPassed: "Submission checks passed",
    switchPages: "Switch project draft pages",
  },
  progress: {
    intake: "Requirement discussion",
    drafting: "Proposal drafting",
    review: "Proposal review",
    draft: "Project draft",
    submitted: "Awaiting team acceptance",
    accepted: "Accepted by team",
    scheduled: "Scheduled",
    inProgress: "In progress",
    awaiting: "Awaiting client acceptance",
    revision: "In revision",
    completed: "Completed",
    completedCount: "{done} / {total} completed",
    blockedCount: "{count} blocked",
    delayed: "Delayed",
    waitClient: "Waiting for client",
    teamWorking: "Team working",
  },
  timeline: {
    title: "Project Gantt chart",
    subtitle: "Planned bars above, actual progress below",
    taskStep: "Task / execution step",
    levelOne: "Level 1",
    levelTwo: "Level 2",
    today: "Today",
    pending: "Pending",
    scheduled: "Scheduled",
    inProgress: "In progress",
    blocked: "Blocked",
    done: "Completed",
    ready: "Awaiting acceptance",
    accepted: "Accepted",
    cancelled: "Cancelled",
    empty:
      "Tasks and execution steps will appear after the team schedules them.",
  },
  execution: {
    videoLabel: "Storyboard execution spec",
    videoNote: "Shots, visuals, dialogue, sound, and acceptance",
    dramaLabel: "Narrative production spec",
    dramaNote: "Story, characters, shots, and continuity",
    designLabel: "Design requirement spec",
    designNote: "Content, visuals, layout, sizes, and delivery",
    websiteLabel: "Product feature spec",
    websiteNote: "Modules, functions, fields, states, and permissions",
    developmentLabel: "Technical implementation contract",
    developmentNote: "Interfaces, data, validation, failures, and acceptance",
    articleLabel: "Content production spec",
    articleNote: "Structure, facts, tone, length, and publishing",
    defaultLabel: "Execution requirement spec",
    defaultNote: "Client-confirmed content and verifiable acceptance criteria",
    tableTitles: {
      storyboard: "Shot-by-shot storyboard and content",
      asset_continuity: "Cross-shot visual and audio continuity",
      delivery_qa: "Final video delivery QA",
      story_bible: "Story, character, and episode bible",
      narrative_storyboard: "Narrative shot-by-shot storyboard",
      continuity_qa: "Narrative continuity and final QA",
      poster_spec: "Poster visual and copy requirements",
      logo_spec: "Logo / VI design specification",
      packaging_spec: "Packaging layout and print content",
      ui_screen_spec: "Screens, components, and states",
      illustration_spec: "Character and illustration anchors",
      design_qa: "Design and source-file QA",
      website_module: "Pages, modules, and feature requirements",
      user_flow_state: "User flow, state, and permission matrix",
      experience_acceptance: "Product experience and release acceptance",
      technical_contract: "Technical module, API, and data contract",
      test_matrix: "Test and acceptance evidence matrix",
      release_plan: "Release, monitoring, and rollback plan",
      article_outline: "Content structure, facts, and publishing requirements",
      fact_source_matrix: "Fact, evidence, and locked wording matrix",
      publication_qa: "Content publishing and delivery QA",
    },
    columnLabels: {
      镜头: "Shot",
      计划时长: "Planned duration",
      画面内容与动作: "Visual and action",
      "角色/画面与动作": "Character / visual / action",
      "台词/字幕": "Dialogue / subtitles",
      "声音/转场": "Sound / transition",
      验收要点: "Acceptance point",
      锚点: "Anchor",
      已确认内容: "Confirmed content",
      跨镜头保持项: "Keep across shots",
      允许变化: "Allowed changes",
      核查方式: "Verification",
      检查维度: "QA dimension",
      检查内容: "Check",
      通过标准: "Pass criteria",
      "证据/输出": "Evidence / output",
      核查证据: "Evidence",
      设定维度: "Bible dimension",
      锁定内容: "Locked content",
      本集用途: "Episode purpose",
      不可改变项: "Immutable",
      待执行补全: "Execution follow-up",
      前后连续性: "Continuity",
      "成品/编号": "Deliverable / number",
      锁定文案: "Locked copy",
      画面内容: "Visual content",
      信息层级: "Information hierarchy",
      "尺寸/比例": "Size / ratio",
      视觉限制: "Visual restrictions",
      交付格式: "Delivery format",
      "版面/部位": "Panel / area",
      必须内容: "Required content",
      视觉要求: "Visual requirements",
      "结构/尺寸": "Structure / size",
      印刷限制: "Print constraints",
      输出文件: "Output files",
      "页面/模块": "Screen / module",
      用户目标: "User goal",
      核心内容: "Core content",
      组件与交互: "Components and interaction",
      状态: "States",
      设备适配: "Device adaptation",
      验收: "Acceptance",
      维度: "Dimension",
      确认内容: "Confirmed content",
      一致性要求: "Consistency",
      扩展版本: "Variants",
      设计维度: "Design dimension",
      客户确认内容: "Client-confirmed content",
      执行要求: "Execution requirement",
      "版本/应用": "Variants / applications",
      交付证据: "Delivery evidence",
      "模块/页面": "Module / page",
      使用角色: "User role",
      核心功能: "Core function",
      输入与字段: "Inputs and fields",
      状态与异常: "States and failures",
      权限: "Permissions",
      "H5/响应式": "H5 / responsive",
      验收结果: "Acceptance result",
      流程: "Flow",
      "角色/入口": "Role / entry",
      关键步骤: "Key steps",
      成功结果: "Success result",
      "空/失败/中断": "Empty / failure / interruption",
      权限边界: "Permission boundary",
      "恢复/返回": "Recovery / return",
      验收维度: "Acceptance dimension",
      覆盖范围: "Coverage",
      验证方式: "Verification method",
      "模块/接口": "Module / API",
      改动目标: "Change goal",
      输入: "Input",
      "输出/数据变更": "Output / data change",
      权限与校验: "Permissions and validation",
      "失败/重试/幂等": "Failure / retry / idempotency",
      "依赖/兼容": "Dependencies / compatibility",
      验收用例: "Acceptance cases",
      "场景/用例": "Scenario / case",
      "前置条件/输入": "Precondition / input",
      预期结果: "Expected result",
      测试层级: "Test level",
      证据: "Evidence",
      环境: "Environment",
      "配置/密钥": "Configuration / secrets",
      数据迁移: "Data migration",
      发布策略: "Rollout strategy",
      上线验证: "Production verification",
      监控: "Monitoring",
      回退条件与动作: "Rollback trigger and action",
      "章节/内容块": "Section / content block",
      表达目的: "Communication purpose",
      "事实/来源": "Facts / sources",
      语气与篇幅: "Tone and length",
      发布元素: "Publishing elements",
      "事实/主张": "Fact / claim",
      "来源/证据": "Source / evidence",
      使用位置: "Placement",
      允许改写: "Rewrite policy",
      核查状态: "Verification status",
      "输出/证据": "Output / evidence",
    },
  },
  asset: {
    previewFailed: "Preview failed",
    downloadOriginal: "Download original",
    closePreview: "Close preview",
    loading: "Loading preview...",
    unsupported: "This file cannot be previewed online.",
    download: "Download file",
  },
};
